// ======================================
// Forgot Password Page Module
// ======================================

import { icons } from '../../components.js';
import { isAuthenticated } from '../../lib/auth.js';

export function renderForgotPasswordPage() {
  // Redirect if already logged in
  if (isAuthenticated()) {
    setTimeout(() => {
      window.location.href = '/';
    }, 0);
    return '<div class="loading">Redirecting...</div>';
  }

  return `
    <section class="auth-section">
      <div class="auth-container auth-container-single">
        <div class="auth-card">
          <div class="auth-header">
            <a href="/login" class="auth-back">
              ${icons.arrowLeft || '←'} Back to Login
            </a>
            <h1 class="auth-title">Reset Your Password</h1>
            <p class="auth-subtitle">Enter your email and we'll send you a reset link</p>
          </div>
          
          <form class="auth-form" id="forgot-password-form">
            <div class="form-group">
              <label class="form-label" for="reset-email">Email Address</label>
              <input type="email" id="reset-email" name="email" class="form-input" 
                     placeholder="Enter your email" required autocomplete="email">
            </div>
            
            <div id="forgot-message" class="auth-message" style="display: none;"></div>
            
            <button type="submit" class="btn btn-primary btn-lg btn-block" id="reset-btn">
              Send Reset Link
            </button>
          </form>
          
          <div class="auth-footer">
            <p>Remember your password? <a href="/login" class="auth-link">Sign In</a></p>
          </div>
          
          <div class="auth-divider">
            <span>Need Help?</span>
          </div>
          
          <div class="quick-actions">
            <a href="tel:+919876543210" class="btn btn-outline btn-sm">Call Support</a>
            <a href="https://wa.me/919876543210" class="btn btn-outline btn-sm" target="_blank">WhatsApp</a>
          </div>
        </div>
      </div>
    </section>
  `;
}

export function initForgotPasswordPage() {
  const form = document.getElementById('forgot-password-form');
  const messageDiv = document.getElementById('forgot-message');
  const submitBtn = document.getElementById('reset-btn');

  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const email = form.email.value.trim();

    if (!email) {
      showMessage('Please enter your email address', 'error');
      return;
    }

    // Show loading state
    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span class="spinner"></span> Sending...';
    messageDiv.style.display = 'none';

    try {
      // For now, show a success message (actual password reset requires email server setup)
      // In production, this would call: await post('/auth/forgot-password', { email });

      await new Promise(resolve => setTimeout(resolve, 1500)); // Simulate API call

      showMessage(
        'If an account exists with this email, you will receive a password reset link shortly.',
        'success'
      );

      submitBtn.innerHTML = '✓ Email Sent';
      form.email.disabled = true;

    } catch (error) {
      showMessage(error.message || 'Failed to send reset email. Please try again.', 'error');
      submitBtn.disabled = false;
      submitBtn.innerHTML = 'Send Reset Link';
    }
  });

  function showMessage(message, type) {
    messageDiv.textContent = message;
    messageDiv.className = `auth-message auth-message-${type}`;
    messageDiv.style.display = 'block';
  }
}
